var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1,5.5c-0.3-0.1-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.5,0.6c-0.1,0.3,0,0.5,0.1,0.7c0.1,0.2,0.3,0.4,0.6,0.5 c0.3,0.1,0.5,0,0.7-0.1c0.2-0.1,0.4-0.3,0.5-0.6c0.1-0.3,0-0.5-0.1-0.7C14.5,5.8,14.3,5.6,14.1,5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,15.7L14.2,15.7c-0.9,0.3-2.1,1.1-1.9,0.1l1.8-6.7c0.2-0.9-1.1-0.9-2-0.5c-0.9,0.4-2.1,1.3-2.8,1.9 c-0.1,0.1-0.2,0.3-0.1,0.5c0.1,0.2,0.3,0.2,0.4,0.2l0,0c0.9-0.3,2.1-1.1,1.8-0.1l-1.8,6.7c-0.2,0.9,1.1,0.9,2,0.5 c0.9-0.4,2.1-1.3,2.8-1.9c0.1-0.1,0.2-0.3,0.1-0.5C14.5,15.7,14.3,15.7,14.2,15.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,2C9.3,2,6.8,3.1,4.9,4.9C3.1,6.8,2,9.3,2,12c0,2.7,1.1,5.2,2.9,7.1C6.8,20.9,9.3,22,12,22c2.7,0,5.2-1.1,7.1-2.9 c1.9-1.9,2.9-4.4,2.9-7.1c0-1.8-0.5-3.5-1.3-5S18.5,4.2,17,3.3C15.5,2.5,13.8,2,12,2L12,2z M12,20.9c-2.4,0-4.6-0.9-6.3-2.6 C4,16.6,3.1,14.4,3.1,12c0-2.4,0.9-4.6,2.6-6.3S9.6,3.1,12,3.1c2.4,0,4.6,0.9,6.3,2.6c1.7,1.7,2.6,3.9,2.6,6.3 c0,2.4-0.9,4.6-2.6,6.3C16.6,19.9,14.4,20.9,12,20.9L12,20.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.368b68cb3226badd884b2cf3fff505f3.svg";
export { ForwardRef as ReactComponent };